/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {CTCEntity} from '@ion/core/src/types/entities';

/**
 * Provides a utility hook for getting the swap operation results
 * for any entity via its respective reducer ...
 *
 * ```typescript
 *
 *   import {useSwapResults} from '@ion/dls/src/hooks/';
 *   const swapResults = useSwapResults('reducer');
 *
 * ```
 */
export const useSwapResults = (reducer: string): CTCEntity | CTCEntity[] => {
  return useSelector(({[reducer]: {clone}}) => clone?.result);
};

export default useSwapResults;
